function r(t) {
  return i(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function e(t) {
  var n;
  return (t == null || (n = t.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function u(t) {
  var n;
  return (n = (i(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : n.documentElement;
}
function i(t) {
  return t instanceof Node || t instanceof e(t).Node;
}
function c(t) {
  return t instanceof Element || t instanceof e(t).Element;
}
function f(t) {
  return t instanceof HTMLElement || t instanceof e(t).HTMLElement;
}
function o(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof e(t).ShadowRoot;
}
function s(t) {
  return ["html", "body", "#document"].includes(r(t));
}
function d(t) {
  return e(t).getComputedStyle(t);
}
function m(t) {
  if (r(t) === "html")
    return t;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    o(t) && t.host || // Fallback.
    u(t)
  );
  return o(n) ? n.host : n;
}
export {
  d as getComputedStyle,
  u as getDocumentElement,
  r as getNodeName,
  m as getParentNode,
  e as getWindow,
  c as isElement,
  f as isHTMLElement,
  s as isLastTraversableNode,
  i as isNode,
  o as isShadowRoot
};
//# sourceMappingURL=floating-ui.utils.dom.js.map
